import {route} from "ziggy-js";

export const getDataApi = (values) => {
    return axios.post(route('getDataFromBuyOneClick'), values);
};
